import Chart from "react-apexcharts";
import React, {useState} from "react";
import {Button, ConfigProvider, Table} from "antd";
import {alarmChartOptions} from "../Constants";
import {normalizeArrayOfObjectsIntoSingleObject} from "../../../utils/arrayUtils";
import {useDispatch} from "react-redux";
import {SET_SINGLE_METER_VALUE, SET_VIEW_SINGLE_METER} from "../../../store/features/systemAnalysisSlice";
import { clientColumnSorter } from "../../../utils/tableClientSort";

// eslint-disable-next-line import/prefer-default-export,react/prop-types
export function AlarmAnalysis({showTable = false, analysisData = {}}) {
    return (
        <div className="grid grid-cols-2 gap-4">
            <div className={`${showTable ? "" : "col-span-2"}`}>
                <AlarmAnalysisChart analysisData={analysisData}/>
            </div>
            {showTable && (
                <div>
                    <AlarmAnalysisTable analysisData={analysisData}/>
                </div>
            )}
        </div>
    );
}

function AlarmAnalysisChart({analysisData = {}}) {
    return (
        <Chart
            key="AlarmAnalysisContentChart"
            options={{
                chart: alarmChartOptions?.options?.chart,
                labels: analysisData?.chart?.labels ?? [],
                colors: ["#6EC3E2", "#FF9933", "#800080", "#32CD32", "#DC143C", "#FFD700", "#008080", "#A0522D", "#FF00FF", "#9ACD32", "#FF7F50"],

            }}
            series={analysisData?.chart !== undefined ? analysisData?.chart?.series?.map((val) => {
                return {
                    ...val,
                    type: val?.type?.toLowerCase()
                }
            }) : []}
            type="bar"
            height={500}
        />
    );
}

function AlarmAnalysisTable({analysisData = {}}) {
    const dispatch = useDispatch();
    // eslint-disable-next-line no-unused-vars
    const [tableParams, setTableParams] = useState({
        pagination: {
            current: 14,
            pageSize: 3,
            total: analysisData?.tabularDatas?.length ?? 0,
        },
    });

    return (
        <ConfigProvider
            theme={{
                token: {
                    borderRadius: 0,
                },
                components: {
                    Table: {
                        /* here is your component tokens */
                        headerBg: "#F5F5F5",
                        headerColor: "#2F5E8A",
                        headerSortActiveBg: "#F5F5F5",
                        headerSortHoverBg: "#F5F5F5",
                        fixedHeaderSortActiveBg: "#F5F5F5",
                    },
                },
            }}
        >
            <Table
                className="table-striped-rows"
                dataSource={analysisData?.tabularDatas?.map((item) => {
                    return {
                        ...normalizeArrayOfObjectsIntoSingleObject(item?.alarmCountByTypes),
                        serialNumber: item?.serialNumber,
                    }
                }) ?? []}
                //   rowSelection={{ type: "checkbox", ...rowSelection }}
                columns={[
                    {
                        title: "Meter ID",
                        dataIndex: "serialNumber",
                        sorter: clientColumnSorter("serialNumber"),
                        render: (text, record) => {
                            return (
                                <>
                                    <Button
                                        onClick={() => {
                                            dispatch(SET_SINGLE_METER_VALUE(text));
                                            dispatch(SET_VIEW_SINGLE_METER(true));
                                        }}
                                    >
                                        <p className="text-dark-blue-100">{text}</p>
                                    </Button>
                                </>
                            );
                        },
                    },
                    {
                        title: "Low Battery",
                        dataIndex: "Battery",
                        sorter: clientColumnSorter("Battery"),
                    },
                    {
                        title: "Low Flow",
                        dataIndex: "Low Flow",
                        sorter: clientColumnSorter("Low Flow"),
                    },
                    {
                        title: "High Flow",
                        dataIndex: "High Flow",
                        sorter: clientColumnSorter("High Flow"),
                    },
                    {
                        title: "Component Fault",
                        dataIndex: "Component Fault",
                        sorter: clientColumnSorter("Component Fault"),
                    },

                    {
                        title: "Dry",
                        dataIndex: "Dry",
                        sorter: clientColumnSorter("Dry"),
                    },
                    {
                        title: "Burst",
                        dataIndex: "Burst",
                        sorter: clientColumnSorter("Burst"),
                    },
                    {
                        title: "Reverse Flow",
                        dataIndex: "Reverse Flow",
                        sorter: clientColumnSorter("Reverse Flow"),
                    },
                    {
                        title: "EEPROM",
                        dataIndex: "EEPROM",
                        sorter: clientColumnSorter("EEPROM"),
                    },
                    {
                        title: "High Temperature",
                        dataIndex: "High Temp",
                        sorter: clientColumnSorter("High Temp"),
                    },
                    {
                        title: "Others",
                        dataIndex: "Others",
                        sorter: clientColumnSorter("Others"),
                    },
                ]}
                pagination={tableParams}
            />
        </ConfigProvider>
    );
}
